<template>
  <div></div>
</template>

<script>
import * as turf from "@turf/turf";

export default {
  name: "HistogramMap",
  props: {
    featureCollection: {
      required: true // 点数据列表，需要geoJson: FutureCollection<Future<LineString|MultiLineString>>
    },
    map: {
      required: true // mapbox对象
    },
    breadth: {
      required: false, //宽度偏移量
      default: 0.02,
    },
    dataPropertyName: {
      required: true // 属性字段名
    },
    layerId: {
      required: true,
    }
  },
  data() {
    return {
      dataRange: 0,
      dataMin: 0,
      dataMax: 0,
      histogramList: {
        'type': 'FeatureCollection',
        'features': []
      },
      color: ["interpolate", ["linear"], ["get", "pValue"]],
      colorList: ["rgb(38, 255, 0)", "rgb(0, 191, 255)", "rgb(0, 62, 255)", "rgb(255, 0, 179)", "rgb(0, 176, 255)"],
    }
  },
  methods: {
    /**
     * 根据点数据生成矩形面数据
     * @param {点数据对象} geometry coordinates
     * @param {偏移量} offset number
     */
    createSquaredByPoint(coordinates, offset) {
      let smx = coordinates[0];
      let smy = coordinates[1];
      let offset_int = parseFloat(offset);
      return [[smx, smy], [smx, smy + offset_int], [smx - offset_int, smy + offset_int], [smx - offset_int, smy], [smx, smy]];
    },

    initLayer() {
      this.featureCollection.features.forEach(item => {
        let array = this.createSquaredByPoint(item.geometry.coordinates, this.breadth);
        this.histogramList.features.push({
          "geometry": {
            "coordinates": [
              array
            ],
            "type": "Polygon"
          },
          "type": "Feature",
          "properties": item.properties
        })
      })
      //生成数据源
      this.map.addSource(this.layerId, {
        'type': 'geojson',
        'data': this.histogramList
      })
      if (this.dataMin !== this.dataMax) {
        this.map.addLayer({
          'id': this.layerId,
          'type': 'fill-extrusion',
          'source': this.layerId,
          'paint': {
            // Get the `fill-extrusion-color` from the source `color` property.
            'fill-extrusion-color': this.color,
            // Get `fill-extrusion-height` from the source `height` property.
            'fill-extrusion-height': ['get', 'pValue'],

            // Get `fill-extrusion-base` from the source `base_height` property.
            'fill-extrusion-base': 0,

            // Make extrusions slightly opaque to see through indoor walls.
            'fill-extrusion-opacity': 1
          }
        }, 'polygonLayer')
      } else {
        this.map.addLayer({
          'id': this.layerId,
          'type': 'fill-extrusion',
          'source': this.layerId,
          'paint': {
            // Get the `fill-extrusion-color` from the source `color` property.
            'fill-extrusion-color': 'rgb(38, 255, 0)',
            // Get `fill-extrusion-height` from the source `height` property.
            'fill-extrusion-height': ['get', 'pValue'],
            // Get `fill-extrusion-base` from the source `base_height` property.
            'fill-extrusion-base': 0,
            // Make extrusions slightly opaque to see through indoor walls.
            'fill-extrusion-opacity': 1
          }
        }, 'polygonLayer')
      }
      this.mapFitBoundary(this.featureCollection)
    },

    mapFitBoundary(geo) {
      const bbox = turf.bbox(geo)
      this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], {
        linear: false,
        animate: true,
        padding: {top: 120, bottom: 130, left: 190, right: 500},
      })
    },
    removeLayer() {
      if (this.map.getLayer(this.layerId))
        this.map.removeLayer(this.layerId)
      if (this.map.getSource(this.layerId))
        this.map.removeSource(this.layerId)
    }
  },
  mounted() {
    let max = Number.MIN_VALUE;
    let min = Number.MAX_VALUE;
    turf.featureEach(this.featureCollection, (currentPoint) => {
      max = Math.max(max, currentPoint.properties[this.dataPropertyName]);
      min = Math.min(min, currentPoint.properties[this.dataPropertyName]);
    });
    this.dataMin = min;
    this.dataMax = max
    if (this.dataMin !== this.dataMax) {
      this.dataRange = parseFloat(((max - min) / 4).toFixed(1));
      let temp = this.dataMin
      for (let i = 0; i < this.colorList.length; i++) {
        this.color.push(temp)
        this.color.push(this.colorList[i])
        temp = temp + this.dataRange
      }
    }
    this.initLayer()
  },
  destroyed() {
    this.removeLayer()
  }
}
</script>

<style scoped>

</style>
